export default __webpack_public_path__ + "static/media/andador-const.b483478d.jpg";